import EyeColor from './EyeColor';

export default EyeColor;
